import AbstractListView from '@UI/Store/AbstractListView';
import type DocumentTemplateView from '@UI/Store/DocumentTemplates/Views/Document/DocumentTemplateView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `organizationId` names the organization this catalogue belongs to.
 */
class DocumentTemplatesListView extends AbstractListView<DocumentTemplateView> {
	readonly organizationId: number;

	constructor(list: readonly DocumentTemplateView[], organizationId: number) {
		super(list, 'DocumentTemplatesListView');

		this.organizationId = organizationId;

		Object.freeze(this);
	}

	update(template: DocumentTemplateView): DocumentTemplatesListView {
		return new DocumentTemplatesListView(
			this.list.map((entry) => (entry.id === template.id ? template : entry)),
			this.organizationId,
		);
	}
}

export default DocumentTemplatesListView;
